import Image from "next/image";
import "react-image-crop/dist/ReactCrop.css";
import { PublicPageZip } from "@/utils/page";
import { JobGetResponse } from "@/types/job";
import classNames from "classnames";
import Section from "@/components/Section/Section";
import SectionContainer from "@/components/Section/SectionContainer";
import SectionHeader from "@/components/Section/SectionHeader";

interface Section13Props extends React.HTMLAttributes<HTMLElement> {
  job?: JobGetResponse;
  page: any;
  section: any;
}

const TestimonialsSection = ({ job, page, section, ...props }: Section13Props) => {
  return (
    <Section section={section} {...props}>
      <SectionContainer section={section}>
        <SectionHeader section={section} />
        {section?.Testimonials?.map((item: any) => {
          return (
            <div
              className={classNames("flex gap-2", {
                "flex-row-reverse": section?.Orientation === "End",
              })}
              key={item?.id}
            >
              <div className="flex flex-1 flex-col justify-center gap-6">
                {item?.BodyImage?.data?.attributes && (
                  <Image
                    alt={item?.BodyImage?.data?.attributes?.alternativeText}
                    src={item?.BodyImage?.data?.attributes?.url}
                    width={item?.BodyImage?.data?.attributes?.width ?? "100"}
                    height={item?.BodyImage?.data?.attributes?.height ?? "100"}
                    priority
                  />
                )}
                {item?.Body && <div className="text-xl font-bold">{item?.Body}</div>}
                {item?.Underline && <div>{item?.Underline}</div>}
              </div>
              {item?.Image?.data?.attributes && (
                <div className="hidden lg:block lg:flex-1">
                  <Image
                    alt={item?.Image?.data?.attributes?.alternativeText}
                    src={item?.Image?.data?.attributes?.url}
                    width={item?.Image?.data?.attributes?.width ?? "100"}
                    height={item?.Image?.data?.attributes?.height ?? "100"}
                    priority
                  />
                </div>
              )}
            </div>
          );
        })}
      </SectionContainer>
    </Section>
  );
};

export default TestimonialsSection;
